import { AdvancedExchangeMethod } from '~/utils/schemas';

export function resolveExchangeMethod({
  advancedExchangeMethod,
  isNoAdjustmentVariantExchangeEnabled,
  originalProductIdFromPlatform,
  selectedProductIdFromPlatform,
}: {
  advancedExchangeMethod: AdvancedExchangeMethod;
  isNoAdjustmentVariantExchangeEnabled: boolean;
  originalProductIdFromPlatform: string;
  selectedProductIdFromPlatform: string;
}) {
  const isNoAdjustmentExchange =
    isNoAdjustmentVariantExchangeEnabled &&
    originalProductIdFromPlatform === selectedProductIdFromPlatform;

  const exchangeMethod: AdvancedExchangeMethod = isNoAdjustmentExchange
    ? 'NO_PAYMENT_OR_REFUND'
    : advancedExchangeMethod;

  return { isNoAdjustmentExchange, exchangeMethod };
}
